import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import SummaryApi from "../../common";
import { useNavigate } from "react-router-dom";
import pdfMake from "../../fonts/pdfFonts";

function TrainDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [varkaris, setVarkaris] = useState([]);
  const [trains, setTrains] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingTrain, setEditingTrain] = useState(null);
  const [newTrain, setNewTrain] = useState({
    trainName: "",
    trainNumber: "",
    departureTime: "",
    arrivalTime: "",
    route: "",
  });
  const [groups, setGroups] = useState({});
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [selectedTrain, setSelectedTrain] = useState(null);
  const [groupData, setGroupData] = useState({
    pnrNumber: "",
    bogieNumber: "",
    members: [],
  });
  const [activeTrainId, setActiveTrainId] = useState(null);
  const [editingGroup, setEditingGroup] = useState(null);

  const handleTrainClick = async (trainId) => {
    if (activeTrainId === trainId) {
      setActiveTrainId(null); // collapse
    } else {
      setActiveTrainId(trainId); // expand
      await fetchGroups(trainId); // load groups
    }
  };

  useEffect(() => {
    const fetchTrains = async () => {
      try {
        const res = await fetch(`${SummaryApi.getTrainByYatra.url}/${id}`);
        const data = await res.json();
        setTrains(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchTrains();
  }, [id]);

  // ✅ Handle Input
  const handleChange = (e) => {
    setNewTrain({
      ...newTrain,
      [e.target.name]: e.target.value,
    });
  };

  // ✅ Add Train
  const handleAddTrain = async () => {
    try {
      let res;

      if (editingTrain) {
        // UPDATE
        res = await fetch(`${SummaryApi.updateTrain.url}/${editingTrain._id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(newTrain),
        });
      } else {
        // CREATE
        res = await fetch(SummaryApi.createTrain.url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            yatraId: id,
            ...newTrain,
          }),
        });
      }

      const result = await res.json();

      if (res.ok) {
        if (editingTrain) {
          setTrains((prev) =>
            prev.map((t) => (t._id === editingTrain._id ? result.train : t)),
          );
        } else {
          setTrains((prev) => [result.train, ...prev]);
        }

        setShowModal(false);
        setEditingTrain(null);

        setNewTrain({
          trainName: "",
          trainNumber: "",
          departureTime: "",
          arrivalTime: "",
          route: "",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchVarkaris = async () => {
      const res = await fetch(`${SummaryApi.getVarkarisByYatraId.url}/${id}`);
      const data = await res.json();
      setVarkaris(data);
    };

    fetchVarkaris();
  }, [id]);

  const fetchGroups = async (trainId) => {
    const res = await fetch(`${SummaryApi.getTraingroup.url}/${trainId}`);
    const data = await res.json();

    setGroups((prev) => ({
      ...prev,
      [trainId]: data,
    }));
  };

  const handleEdit = (train) => {
    setEditingTrain(train);
    setNewTrain(train);
    setShowModal(true);
  };

  const handleDelete = async (trainId) => {
    if (!window.confirm("Delete this train?")) return;

    try {
      await fetch(`${SummaryApi.deleteTrain.url}/${trainId}`, {
        method: "DELETE",
      });

      setTrains((prev) => prev.filter((t) => t._id !== trainId));
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelectVarkari = (varkari) => {
    const exists = groupData.members.find(
      (m) => m.varkariId?.toString() === varkari._id.toString(),
    );

    if (exists) {
      setGroupData({
        ...groupData,
        members: groupData.members.filter(
          (m) => m.varkariId?.toString() !== varkari._id.toString(),
        ),
      });
    } else {
      setGroupData({
        ...groupData,
        members: [
          ...groupData.members,
          {
            varkariId: varkari._id,
            seatNumber: "",
            seatPosition: "Upper",
          },
        ],
      });
    }
  };

  const handleSeatChange = (index, field, value) => {
    if (index === -1) return; // 🔥 FIX

    const updated = [...groupData.members];

    if (!updated[index]) return; // extra safety

    updated[index] = {
      ...updated[index],
      [field]: value,
    };

    setGroupData({
      ...groupData,
      members: updated,
    });
  };

  const handleEditGroup = (group) => {
    setEditingGroup(group);

    setGroupData({
      pnrNumber: group.pnrNumber,
      bogieNumber: group.bogieNumber,
      members: group.members.map((m) => ({
        varkariId: m.varkariId?._id || m.varkariId, // ✅ FIX
        seatNumber: m.seatNumber || "",
        seatPosition: m.seatPosition || "Upper",
        _id: m._id, // important for remove
      })),
    });

    setShowGroupModal(true);
  };

  const handleDeleteGroup = async (groupId, trainId) => {
    if (!window.confirm("Delete this group?")) return;

    await fetch(`${SummaryApi.deleteTrainGroup.url}/${groupId}`, {
      method: "DELETE",
    });

    fetchGroups(trainId);
  };

  const getUsedVarkariIds = () => {
  if (!selectedTrain || !groups[selectedTrain._id]) return [];

  let used = [];

  groups[selectedTrain._id].forEach((group) => {
    group.members.forEach((m) => {
      const id = m.varkariId?._id || m.varkariId;
      if (id) used.push(id.toString());
    });
  });

  return used;
};


const handleDownloadPDF = () => {
  const train = trains.find((t) => t._id === activeTrainId);
  const groupList = groups[activeTrainId] || [];

  const primaryColor = "#ea580c";
  const lightOrange = "#fff7ed";
  const gray = "#6b7280";

  const content = [];

  // ================= HEADER =================
  content.push({
    table: {
      widths: ["*"],
      body: [
        [
          {
            stack: [
              {
                text: "🚆 रेल्वे गट अहवाल",
                fontSize: 24,
                bold: true,
                color: "white",
                alignment: "center",
                margin: [0, 10, 0, 5],
              },
              {
                text: `Generated On : ${new Date().toLocaleDateString()}`,
                color: "white",
                alignment: "center",
                margin: [0, 0, 0, 10],
              },
            ],
            fillColor: primaryColor,
            border: [false, false, false, false],
          },
        ],
      ],
    },

    layout: {
      hLineWidth: () => 0,
      vLineWidth: () => 0,
    },

    margin: [0, 0, 0, 20],
  });

  // ================= TRAIN INFO =================

  content.push({
    table: {
      widths: ["*"],

      body: [
        [
          {
            stack: [
              {
                text: "🚆 Train Information",
                bold: true,
                fontSize: 16,
                color: primaryColor,
                margin: [0, 0, 0, 10],
              },

              {
                columns: [
                  [
                    {
                      text: `Train Name : ${
                        train?.trainName || "-"
                      }`,
                    },

                    {
                      text: `Train Number : ${
                        train?.trainNumber || "-"
                      }`,
                      margin: [0, 5, 0, 0],
                    },
                  ],

                  [
                    {
                      text: `Route : ${
                        train?.route || "-"
                      }`,
                    },

                    {
                      text: `Time : ${
                        train?.departureTime || "-"
                      } → ${
                        train?.arrivalTime || "-"
                      }`,
                      margin: [0, 5, 0, 0],
                    },
                  ],
                ],
              },
            ],

            fillColor: "#f9fafb",
            margin: [10, 10, 10, 10],
            borderColor: ["#e5e7eb", "#e5e7eb", "#e5e7eb", "#e5e7eb"],
          },
        ],
      ],
    },

    margin: [0, 0, 0, 20],
  });

  // ================= GROUPS =================

  groupList.forEach((group, index) => {
    content.push({
      text: `Group ${index + 1} | PNR : ${
        group.pnrNumber
      } | Bogie : ${group.bogieNumber}`,
      style: "groupHeader",
      margin: [0, 10, 0, 8],
    });

    const body = [
      [
        {
          text: "#",
          style: "tableHeader",
        },

        {
          text: "वारकरी नाव",
          style: "tableHeader",
        },

        {
          text: "Seat No",
          style: "tableHeader",
        },

        {
          text: "Position",
          style: "tableHeader",
        },
      ],
    ];

    group.members.forEach((m, i) => {
      body.push([
        {
          text: i + 1,
          alignment: "center",
        },

        {
          text: m.varkariId?.name || "-",
        },

        {
          text: m.seatNumber || "-",
          alignment: "center",
        },

        {
          text: m.seatPosition || "-",
          alignment: "center",
        },
      ]);
    });

    content.push({
      table: {
        headerRows: 1,

        widths: [30, "*", 70, 70],

        body,
      },

      layout: {
        fillColor: function (rowIndex) {
          if (rowIndex === 0) return primaryColor;

          return rowIndex % 2 === 0
            ? "#fff7ed"
            : null;
        },

        hLineColor: () => "#e5e7eb",

        vLineColor: () => "#e5e7eb",

        hLineWidth: () => 0.7,

        vLineWidth: () => 0.7,
      },

      margin: [0, 0, 0, 20],
    });
  });

  // ================= DOC DEFINITION =================

  const docDefinition = {
    pageSize: "A4",

    pageMargins: [30, 40, 30, 50],

    content,

    footer: function (currentPage, pageCount) {
      return {
        columns: [
          {
            text: "Train Group Management System",
            alignment: "left",
            margin: [30, 0, 0, 0],
            color: gray,
            fontSize: 9,
          },

          {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: "right",
            margin: [0, 0, 30, 0],
            color: gray,
            fontSize: 9,
          },
        ],
      };
    },

    defaultStyle: {
      font: "NotoSansDevanagari",
      fontSize: 11,
    },

    styles: {
      groupHeader: {
        fontSize: 14,
        bold: true,
        color: primaryColor,
      },

      tableHeader: {
        bold: true,
        color: "white",
        alignment: "center",
        margin: [0, 5, 0, 5],
      },
    },
  };

  pdfMake
    .createPdf(docDefinition)
    .download(
      `train-report-${train?.trainNumber || "report"}.pdf`
    );
};
  return (
    <div className="p-6">
       <button
    onClick={() => navigate(-1)}
    className="mr-4 bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded"
  >
    ← Back
  </button>
      {/* 🔥 HEADER */}
      <h2 className="text-2xl font-bold text-orange-600 mb-6">
        🚆 Train Management
      </h2>
      <button
        onClick={() => setShowModal(true)}
        className="mb-6 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
      >
        + Create Train
      </button>

      {/* ================= TRAIN CARDS ================= */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {trains.length > 0 ? (
          trains.map((train, index) => (
            <div key={train._id}>
              {/* MAIN CARD */}
              <div
                onClick={() => handleTrainClick(train._id)}
                className={`bg-white border rounded-lg p-4 shadow cursor-pointer transition 
    ${activeTrainId === train._id ? "border-orange-500" : ""}`}
              >
                <h3 className="text-lg font-bold text-orange-600">
                  {train.trainName}
                </h3>

                <p>🚆 {train.trainNumber}</p>
                <p>
                  ⏰ {train.departureTime} → {train.arrivalTime}
                </p>
                <p className="text-sm text-gray-600">🛤 {train.route}</p>

                {/* ACTIONS */}
                <div className="flex gap-2 mt-3">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(train);
                    }}
                    className="bg-yellow-500 text-white px-2 py-1 rounded text-sm"
                  >
                    Edit
                  </button>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(train._id);
                    }}
                    className="bg-red-500 text-white px-2 py-1 rounded text-sm"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-gray-500">No trains added yet.</p>
        )}
      </div>
      {activeTrainId && (
  <div className="mt-8 bg-white p-6 rounded-lg shadow">

    {/* HEADER */}
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-xl font-bold text-orange-600">
        🚆 Train Groups
      </h3>

      <button
        onClick={() => {
          const train = trains.find(t => t._id === activeTrainId);
          setSelectedTrain(train);
          setEditingGroup(null);
          setGroupData({ pnrNumber: "", bogieNumber: "", members: [] });
          setShowGroupModal(true);
        }}
        className="bg-green-600 text-white px-4 py-2 rounded"
      >
        + Create Group
      </button>
    </div>

    {/* GROUP GRID */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

      {groups[activeTrainId]?.length > 0 ? (
        groups[activeTrainId].map((group) => (
          
          <div
            key={group._id}
            className="bg-gray-50 border rounded-lg p-4 shadow-sm hover:shadow-md transition"
          >
            {/* PNR */}
            <h4 className="font-bold text-blue-600 mb-2">
              PNR: {group.pnrNumber} |  Bogie: {group.bogieNumber}
            </h4>

            {/* MEMBERS */}
            <div className="space-y-1 text-sm">
              {group.members.map((m, i) => (
                <div key={i} className="flex justify-between">
                  <span>👤 {m.varkariId?.name}</span>
                  <span>
                    {m.seatNumber} ({m.seatPosition})
                  </span>
                </div>
              ))}
            </div>

            {/* ACTIONS */}
            <div className="flex gap-2 mt-3">
              <button
                onClick={() => handleEditGroup(group)}
                className="bg-yellow-500 text-white px-2 py-1 text-xs rounded"
              >
                Edit
              </button>

              <button
                onClick={() =>
                  handleDeleteGroup(group._id, activeTrainId)
                }
                className="bg-red-500 text-white px-2 py-1 text-xs rounded"
              >
                Delete
              </button>
            </div>
          </div>

        ))
      ) : (
        <p className="text-gray-500">No groups found</p>
      )}

    </div>
    <button
  onClick={handleDownloadPDF}
  className=" bg-blue-600 mt-5 text-white px-4 py-2 rounded"
>
  📄 Download PDF
</button>
  </div>
)}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-[500px] shadow-lg relative">
            <button
              onClick={() => {
                setShowModal(false);
                setEditingTrain(null);
              }}
              className="absolute top-2 right-2 text-gray-600"
            >
              ✕
            </button>

            <h3 className="text-lg font-semibold mb-4">
              {editingTrain ? "Edit Train" : "Add Train"}
            </h3>

            <div className="grid grid-cols-2 gap-3">
              <input
                type="text"
                name="trainName"
                placeholder="Train Name"
                value={newTrain.trainName}
                onChange={handleChange}
                className="border p-2 rounded"
              />

              <input
                type="text"
                name="trainNumber"
                placeholder="Train Number"
                value={newTrain.trainNumber}
                onChange={handleChange}
                className="border p-2 rounded"
              />

              <input
                type="time"
                name="departureTime"
                value={newTrain.departureTime}
                onChange={handleChange}
                className="border p-2 rounded"
              />

              <input
                type="time"
                name="arrivalTime"
                value={newTrain.arrivalTime}
                onChange={handleChange}
                className="border p-2 rounded"
              />

              <input
                type="text"
                name="route"
                placeholder="Route"
                value={newTrain.route}
                onChange={handleChange}
                className="border p-2 rounded col-span-2"
              />
            </div>

            <button
              onClick={handleAddTrain}
              className="mt-4 bg-blue-600 text-white px-4 py-2 rounded w-full"
            >
              {editingTrain ? "Update Train" : "Create Train"}
            </button>
          </div>
        </div>
      )}
      {showGroupModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">
          <div className="bg-white p-5 rounded w-[600px] max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-3">
              <h3 className="font-bold">
                {editingGroup ? "Edit PNR Group" : "Create PNR Group"}
              </h3>

              <button
                onClick={() => {
                  setShowGroupModal(false);
                  setEditingGroup(null);
                  setGroupData({ pnrNumber: "", bogieNumber: "", members: [] });
                }}
                className="text-gray-600 text-xl"
              >
                ✕
              </button>
            </div>
            {/* PNR */}
            <input
              placeholder="PNR Number"
              className="border p-2 w-full mb-3"
              value={groupData.pnrNumber}
              onChange={(e) =>
                setGroupData({ ...groupData, pnrNumber: e.target.value })
              }
            />
             <input
              placeholder="Bogie Number"
              className="border p-2 w-full mb-3"
              value={groupData.bogieNumber}
              onChange={(e) =>
                setGroupData({ ...groupData, bogieNumber: e.target.value })
              }
            />

            {/* 🔥 VARKARI LIST */}
            <div className="space-y-2">
             {varkaris
  .filter((v) => {
    const usedIds = getUsedVarkariIds();

    // ✅ Allow already selected members (for edit)
    const isAlreadySelected = groupData.members.find(
      (m) => m.varkariId?.toString() === v._id.toString()
    );

    if (isAlreadySelected) return true;

    // ❌ hide if already used in other group
    return !usedIds.includes(v._id.toString());
  })
  .map((v) => {
                const selected = groupData.members.find(
                  (m) => m.varkariId?.toString() === v._id.toString(),
                );

                return (
                  <div key={v._id} className="border p-2 rounded">
                    {/* SELECT */}
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={!!selected}
                        onChange={() => handleSelectVarkari(v)}
                      />
                      <span>
                        {v.name} ({v.mobileNo})
                      </span>
                    </div>

                    {/* SEAT INPUT */}
                    {selected && (
                      <div className="grid grid-cols-2 gap-2 mt-2">
                        <input
                          placeholder="Seat Number"
                          className="border p-1"
                          value={selected?.seatNumber || ""}
                          onChange={(e) => {
                            const index = groupData.members.findIndex(
                              (m) =>
                                m.varkariId?.toString() === v._id.toString(),
                            );

                            if (index === -1) return;

                            handleSeatChange(
                              index,
                              "seatNumber",
                              e.target.value,
                            );
                          }}
                        />

                        <select
                          className="border p-1"
                          value={selected.seatPosition}
                          onChange={(e) => {
                            const index = groupData.members.findIndex(
                              (m) =>
                                m.varkariId?.toString() === v._id.toString(),
                            );

                            if (index === -1) return;

                            handleSeatChange(
                              index,
                              "seatPosition",
                              e.target.value,
                            ); // ✅ FIX
                          }}
                        >
                          <option>Upper</option>
                          <option>Middle</option>
                          <option>Lower</option>
                        </select>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* SAVE */}
            <button
              onClick={async () => {
                let res;

                const payload = {
                  trainId: selectedTrain?._id,
                  yatraId: id,
                  pnrNumber: groupData.pnrNumber,
                  bogieNumber: groupData.bogieNumber,
                  members: groupData.members.map((m) => ({
                    varkariId: m.varkariId,
                    seatNumber: m.seatNumber,
                    seatPosition: m.seatPosition,
                  })),
                };

                try {
                  if (editingGroup) {
                    res = await fetch(
                      `${SummaryApi.updateTrainGroup.url}/${editingGroup._id}`,
                      {
                        method: "PUT",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload),
                      },
                    );
                  } else {
                    res = await fetch(SummaryApi.createTrainGroup.url, {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify(payload),
                    });
                  }

                  const data = await res.json();

                  if (!res.ok) {
                    alert(data.message || "Something went wrong");
                    return;
                  }

                  await fetchGroups(selectedTrain._id);

                  setShowGroupModal(false);
                  setEditingGroup(null);
                  setGroupData({ pnrNumber: "",bogieNumber: "", members: [] });
                } catch (err) {
                  console.error(err);
                  alert("Server error");
                }
              }}
              className="mt-4 bg-green-600 text-white px-4 py-2 rounded w-full"
            >
              Save Group
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default TrainDetails;
